import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'productCategoryPut',
    method: 'PUT',
  });
  useEffect(() => {
    if (param) {
      exec({ url: `/api/product_types/${param.id}`, data: param })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, exec];
});